'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$CreateA3(username, pin, serial, thumbprint, location) {
  this.Zm = null;
  this.Zj = null;
  this.Zk = null;
  this.Zl = null;
  this.Zi = null;
  this.Zm = username;
  this.Zj = pin;
  this.Zk = serial;
  this.Zl = thumbprint;
  this.Zi = location;
}
export { $c_Lpresto_types$proto$CreateA3 as $c_Lpresto_types$proto$CreateA3 };
$p = $c_Lpresto_types$proto$CreateA3.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$CreateA3;
/** @constructor */
function $h_Lpresto_types$proto$CreateA3() {
}
export { $h_Lpresto_types$proto$CreateA3 as $h_Lpresto_types$proto$CreateA3 };
$h_Lpresto_types$proto$CreateA3.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$proto$CreateA3)) {
    if (((((this.Zm === x$0.Zm) && (this.Zj === x$0.Zj)) && (this.Zk === x$0.Zk)) && (this.Zl === x$0.Zl))) {
      var x = this.Zi;
      var x$2 = x$0.Zi;
      return ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 5;
});
$p.s = (function() {
  return "CreateA3";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.Zm;
      break;
    }
    case 1: {
      return this.Zj;
      break;
    }
    case 2: {
      return this.Zk;
      break;
    }
    case 3: {
      return this.Zl;
      break;
    }
    case 4: {
      return this.Zi;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lpresto_types$proto$CreateA3(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kP)));
}
export { $isArrayOf_Lpresto_types$proto$CreateA3 as $isArrayOf_Lpresto_types$proto$CreateA3 };
var $d_Lpresto_types$proto$CreateA3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$CreateA3, "presto.types$proto$CreateA3", ({
  kP: 1,
  bx: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$proto$CreateA3 as $d_Lpresto_types$proto$CreateA3 };
//# sourceMappingURL=presto.types$proto$-Create-A3.js.map
